import { render, staticRenderFns } from "./StudioPlaylistContent.vue?vue&type=template&id=27169966&scoped=true&"
import script from "./StudioPlaylistContent.vue?vue&type=script&lang=js&"
export * from "./StudioPlaylistContent.vue?vue&type=script&lang=js&"
import style0 from "./StudioPlaylistContent.vue?vue&type=style&index=0&id=27169966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27169966",
  null
  
)

export default component.exports